import { Route, Routes, Outlet } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import Layout from './Component/Layout'
import Admin_Home from './Component/Admin_Components/Admin_Home';
import Organisation from './Component/organisation_component/organisation'
import UserHomePage from './Component/user/UserHomePage';
import UserRegistration from './Component/user_registration/UserRegistration';
import StaffComponent from './Component/organisation_component/StaffComponent';
import HomeCheckListComponent from './Component/organisation_component/HomeCheckListComponent';
import HomeMainComponent from './Component/organisation_component/HomeMainComponent';
import RoleTemplate from './Component/organisation_component/RoleTemplate';
import StaffRoleCourseChecklistComponent from './Component/organisation_component/StaffRoleCourseChecklistComponent';
import Homepage from './Component/Homepage';
import AboutPage from './Component/aboutUs';
import ContactPage from './Component/contactUs';
import TermsOfUsePage from './Component/termsOfUse';
import PrivacyPolicyPage from './Component/privacyPolicy';
import Login from './Component/login/Login';
import { useLocation } from "react-router-dom";
import MaintenancePage from './config/MaintenancePage';
import MasterAppProvider from './config/MasterAppProvider';
import HomeThemeProvider from './config/HomeThemeProvider';
import {
  Experimental_CssVarsProvider as CssVarsProvider,
  experimental_extendTheme as extendMuiTheme,
  THEME_ID as MATERIAL_THEME_ID,
} from '@mui/material/styles';
import { extendTheme as extendJoyTheme } from '@mui/joy/styles';
import { deepmerge } from '@mui/utils';

// 1. Create the themes
const muiTheme = extendMuiTheme(); // Material UI theme
const joyTheme = extendJoyTheme(); // Joy UI theme

// 2. Merge them correctly
const mergedTheme = deepmerge(muiTheme, joyTheme);


function App() {
  const { pathname } = useLocation();
  const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true' || process.env.REACT_APP_MAINTENANCE_MODE === true;
  if (isMaintenanceMode) {
    return <MaintenancePage />;
  }

  const LayoutWrapper = () => (
    <Layout data={pathname}>
      <Outlet />
    </Layout>
  );

  return (
    //  <CssVarsProvider
    //   theme={mergedTheme}
    // >
    <HomeThemeProvider>
      <MasterAppProvider>
        <Routes>
          {/* Login routes: /login and /:home/login */}
          <Route path="/login" element={<Login />} />
          <Route path=":home/login" element={<Login />} />

          {/* Main app routes (no home in URL) */}
          <Route path="/" element={<LayoutWrapper />}>
            <Route index element={<Homepage />} />
            <Route path="admin" element={<Admin_Home />} />
            <Route path="organisation/:id" element={<Organisation />} />
            <Route path="home/:id" element={<HomeMainComponent />} />
            <Route path="checkList/:id" element={<HomeCheckListComponent />} />
            <Route path="showStaff/:id" element={<StaffComponent />} />
            <Route path="roleTemplate/:homeId/:roleId" element={<RoleTemplate />} />
            <Route path="user/:id" element={<UserHomePage />} />
            <Route path="getStaffCourseRoleCheckList/:userId/:homeId" element={<StaffRoleCourseChecklistComponent />} />
            <Route path="userRegistration" element={<UserRegistration />} />
            <Route path="aboutUs" element={<AboutPage />} />
            <Route path="contactUs" element={<ContactPage />} />
            <Route path="privacy_policy" element={<PrivacyPolicyPage />} />
            <Route path="terms_of_use" element={<TermsOfUsePage />} />
            <Route path="*" element={<div>404 NOT FOUND</div>} />
          </Route>
        </Routes>
      </MasterAppProvider>
    </HomeThemeProvider>
    // </CssVarsProvider>
  );
}

export default App;
